module.exports = __webpack_public_path__ + "static/rozpuszczalna_stosik-807b688715ddceaec5bfd9606f29bcdb.png";